import _ from "lodash";
import { connect } from "react-redux";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { TextInput } from "react-spark";

import * as actions from "../../actions/google-address-verify";
import * as selectors from "../../state-selectors/google-address-verify";

export class GoogleAddressInput extends Component {
  constructor(props) {
    super(props);

    this.debounceFetchAddressPredictions = _.debounce(function(text) {
      const { clearAddressPredictions, fetchAddressPredictions } = this.props;
      if (text) {
        fetchAddressPredictions(text);
      } else {
        clearAddressPredictions();
      }
    }, 200);
  }

  getActivePrediction(predictions) {
    return _.find(predictions, item => item.active);
  }

  getActivePredictionIndex(predictions) {
    return _.findIndex(predictions, item => item.active);
  }

  handleInputChange(text) {
    const {
      updateAddressInput,
      clearAddressInput,
      setPendingAddressPredictionsFetch
    } = this.props;
    if (text) {
      updateAddressInput(text);
      setPendingAddressPredictionsFetch(true);
    } else {
      clearAddressInput();
    }
    this.debounceFetchAddressPredictions(text);
  }

  handleInputKeyDown(event) {
    const {
      addressPredictions = [],
      selectPrediction,
      clearAddressInput,
      setActivePrediction
    } = this.props;
    const activePrediction = this.getActivePrediction(addressPredictions);
    const currentIndex = this.getActivePredictionIndex(addressPredictions);
    switch (event.key) {
      case "Enter":
        event.preventDefault();
        if (activePrediction) {
          selectPrediction(activePrediction);
        } else {
          clearAddressInput();
        }
        break;
      case "ArrowDown":
        event.preventDefault();
        if (addressPredictions.length !== 0) {
          if (activePrediction === undefined) {
            setActivePrediction(0);
          } else {
            const nextIndex = (currentIndex + 1) % addressPredictions.length;
            setActivePrediction(nextIndex);
          }
        }
        break;
      case "ArrowUp":
        event.preventDefault();
        if (addressPredictions.length !== 0) {
          if (activePrediction === undefined) {
            setActivePrediction(addressPredictions.length - 1);
          } else if (currentIndex === 0) {
            setActivePrediction(addressPredictions.length - 1);
          } else {
            const nextIndex = (currentIndex - 1) % addressPredictions.length;
            setActivePrediction(nextIndex);
          }
        }
        break;
      case "Escape":
        clearAddressInput();
        break;
    }
  }

  handleInputBlur() {
    const {
      clearAddressPredictions,
      inputInsufficient,
      setHasSeenError
    } = this.props;
    clearAddressPredictions();
    if (inputInsufficient && inputInsufficient === "true") {
      setHasSeenError(true);
    }
  }

  handlePaste() {
    if(this.props.context && this.props.context.addPField) {
      this.props.context.addPField('googleAddress');
    }
  }

  render() {
    const { addressInput, error, placeholder, helper } = this.props;
    const label = placeholder || "Current Home Address";

    return (
      <TextInput
        error={error}
        id="google-address-input"
        autoComplete="none"
        label={label}
        name="googleAddressVerifyInput"
        helper={helper}
        onChange={e => this.handleInputChange(e.target.value)}
        onKeyDown={e => this.handleInputKeyDown(e)}
        onBlur={() => this.handleInputBlur()}
        onPaste={() => this.handlePaste()}
        value={addressInput}
      />
    );
  }
}

GoogleAddressInput.propTypes = {
  inputInsufficient: PropTypes.string,
  fetchAddressPredictions: PropTypes.func,
  clearAddressPredictions: PropTypes.func,
  clearAddressInput: PropTypes.func,
  setActivePrediction: PropTypes.func,
  selectPrediction: PropTypes.func,
  updateAddressInput: PropTypes.func,
  setPendingAddressPredictionsFetch: PropTypes.func,
  addressInput: PropTypes.string,
  selectedAddress: PropTypes.shape({
    streetAddress: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    formattedAddress: PropTypes.string,
    htmlAttributions: PropTypes.array,
    isValid: PropTypes.bool
  }),
  addressPredictions: PropTypes.arrayOf(
    PropTypes.shape({
      suggestion: PropTypes.string,
      placeId: PropTypes.string,
      active: PropTypes.bool,
      index: PropTypes.number,
      formattedSuggestion: PropTypes.object
    })
  )
};

GoogleAddressInput.defaultProps = {
  addressInput: ""
};

const mapStateToProps = state => ({
  addressPredictions: selectors.getAddressPredictions(state),
  addressInput: selectors.getAddressInput(state),
  selectedAddress: selectors.getSelectedAddress(state)
});

const mapDispatchToProps = dispatch => ({
  fetchAddressPredictions: query =>
    dispatch(actions.fetchAddressPredictions(query)),
  clearAddressPredictions: () => dispatch(actions.clearAddressPredictions()),
  clearAddressInput: () => dispatch(actions.clearAddressInput()),
  setActivePrediction: index => dispatch(actions.setActivePrediction(index)),
  selectPrediction: prediction =>
    dispatch(actions.selectPrediction(prediction)),
  updateAddressInput: text => dispatch(actions.updateAddressInput(text)),
  setPendingAddressPredictionsFetch: isPending =>
    dispatch(actions.setPendingAddressPredictionsFetch(isPending)),
  setHasSeenError: hasSeen => dispatch(actions.setHasSeenError(hasSeen))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GoogleAddressInput);
